module.exports = __webpack_public_path__ + "static/media/otLogo.c38450d1.png";